import {
  Button,
  Col,
  Descriptions,
  Divider,
  QRCode,
  Row,
  Space,
  Typography,
} from "antd";
import { HeaderPrintForm } from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useAppSelector } from "redux/hooks";
import { formatDateToString, getAge } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import "./GlassPrint.scss";
import GlassesPrescriptionPrint from "./GlassesPrescription/GlassesPrescription";
import { InfoItem } from "components/common/PrintForm";
import { removeEmpty } from "helper/refraction";
const GlassPrint = (props) => {
  const { closeModal, form } = props;

  const printRef = useRef<any>();
  const detailBill = useAppSelector((state) => state.glassKiot.detailBill);
  const detailPhieu = {
    ...detailBill?.glassesSalesDto,
    ...form.getFieldsValue(),
  };
  // const [newData, setNewData] = useState(null);
  // console.log("🚀 ~ file: GlassPrint.tsx:31 ~ GlassPrint ~ newData:", newData)
  // useEffect(() => {
  // console.log(detailPhieu);
  const removeData = removeEmpty(detailPhieu);
  // setNewData(removeData);
  // }, [dataPhieu]);

  const fields1 = [
    { label: "Họ và tên", value: detailPhieu?.hoTen },
    {
      label: "Ngày sinh",
      value: formatDateToString(detailPhieu?.ngaySinh, FORMAT_TIME.dayFull),
    },
    { label: "Giới tính", value: detailPhieu?.gioiTinh == 0 ? "Nam" : "Nữ" },
    { label: "Điện thoại", value: detailPhieu?.dienThoai },
  ];
  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(detailPhieu?.thoiGianKham, FORMAT_TIME.dateTime),
    },
    { label: "Mã phiếu khám", value: detailPhieu?.idPhieuKham },
    { label: "Mã bệnh nhân", value: detailPhieu?.maBenhNhan },
  ];
  const fields3 = [
    { label: "Địa chỉ", value: detailPhieu?.diaChi },

    {
      label: "Lý do khám",
      value: detailPhieu?.chiefComplaints,
    },
  ];

  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="print-form-don-kinh">
      <div ref={printRef} className="print-don-kinh">
        <HeaderPrintForm />

        <div>
          <InfoItem
            fields1={fields1}
            fields2={fields2}
            fields3={fields3}
            idBenhNhan={detailPhieu?.maBenhNhan}
            title={"ĐƠN KÍNH"}
            isChiefComplant={false}
          />
          <Divider />
          <div className="position-eye">
            <span>Mắt phải</span>
            <span style={{ marginRight: "8px" }}>Mắt trái</span>
          </div>
          <div className="container1">
            {removeData?.glassesPrescription && (
              <GlassesPrescriptionPrint
                detailPhieu={removeData?.glassesPrescription}
              />
            )}
          </div>
          <Sign
            time={detailPhieu?.thoiGianKham}
            nguoiThucHien={detailPhieu?.tenBacSy ?? ""} />
        </div>
      </div>
      <Row justify={"end"} gutter={8}>
        <Col>
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
        </Col>
        <Col>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-form-don-kinh"
          />
        </Col>
      </Row>
    </div>
  );
};
export default GlassPrint;
